import leftArrow from '../../images/OP_Portal_Arrow_White_LT.svg'
import rightArrow from '../../images/OP_Portal_Arrow_White_RT.svg'

export {leftArrow, rightArrow};
